import { Routes } from "@angular/router";
import { WorkflowPartnerOneCancelPhonenumberComponent } from "./workflow-partner-one-cancel-phonenumber.component";

export const workflowPartnerOneCancelPhonenumberRouting: Routes = [
    { path: 'partner/cancel-phonenumber/:aid/:bid', component: WorkflowPartnerOneCancelPhonenumberComponent, children: [
        { path: 'confirm', component: WorkflowPartnerOneCancelPhonenumberComponent, data: { step: 'confirm' } },
        { path: 'contact', component: WorkflowPartnerOneCancelPhonenumberComponent, data: { step: 'contact' } },
        { path: 'address', component: WorkflowPartnerOneCancelPhonenumberComponent, data: { step: 'address' } },
        { path: 'payment', component: WorkflowPartnerOneCancelPhonenumberComponent, data: { step: 'payment' } },
        { path: 'checkout-summary', component: WorkflowPartnerOneCancelPhonenumberComponent, data: { step: 'checkout-summary' } },
        { path: 'complete', component: WorkflowPartnerOneCancelPhonenumberComponent, data: { step: 'complete' } },
        { path: '', redirectTo: 'confirm', pathMatch: 'full' },
    ]},
]